import React, { useRef, useEffect, useState } from 'react';
import { Form, Button } from 'react-bootstrap';

const VideoPreview = ({ login }) => {
	const [roomName, setRoomName] = useState('');
	const [identity, setIdentity] = useState('');

	return (
		<div className="mb-3">
			<h3>Preview</h3>
			<Form>
				<Form.Group controlId="1">
					<Form.Label>identity</Form.Label>
					<Form.Control
						type="text"
						placeholder="Enter identity"
						value={identity}
						onChange={e => setIdentity(e.target.value)}
						/>
				</Form.Group>
				<Form.Group controlId="2">
					<Form.Label>room name</Form.Label>
					<Form.Control
						type="text"
						value={roomName}
						placeholder="Enter room name"
						onChange={e => setRoomName(e.target.value)}
						/>
				</Form.Group>
				<Button variant="btn btn-primary" onClick={() => login({identity, roomName}) }>
					Login
				</Button>
			</Form>

			{/* <input type="text" name="identity" value={identity} onChange={e => setIdentity(e.target.value)} />
			<input type="text" name="room name" value={roomName} onChange={ e => setRoomName(e.target.value)} />
			<button onClick={() => login()} className='btn btn-primary'>Login</button> */}
		</div>
	);
}

export default VideoPreview;
